import React from 'react';
import { IMaskInput } from 'react-imask';
import { InputBaseComponentProps } from '@mui/material';
import { FormWrapper, InputWrapper } from './Wrappers';
import { genericMemo } from './Types';

export function isValidQuantity(quantity: number | null) {
  return quantity !== null && quantity > 0
}

function QuantityInputIMask({onChange, ...props}: {onChange?: (newValue: string) => void} & InputBaseComponentProps) {
  return (
    <IMaskInput
      {...props}
      mask={Number}
      scale={0}
      min={0}
      max={9999}
      thousandsSeparator=' '
      padFractionalZeros= {true}
      unmask={true}
      onAccept={(value, _mask, event) => {if (event !== undefined && onChange !== undefined) { onChange(value) }}}
    />
  )
}

const QuantityInputWrapped = InputWrapper(QuantityInputIMask)

function QuantityInputRaw({onChange, value, ...props}: {onChange: (newValue: number | null) => void, value: number | null}) {
  return (
    <QuantityInputWrapped
      {...props}
      value={value === null ? '' : value.toString()}
      onChange={value => onChange(value === '' ? null : Number(value))}
    />
  )
}

const QuantityInput = genericMemo(FormWrapper({Component: QuantityInputRaw, validationFunction: isValidQuantity}))

export default QuantityInput
